/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetLanguagesForCreateBranchDocument = gql`
    query GetLanguagesForCreateBranch($companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      languages {
        id
        name
        isoCode
      }
      primaryLanguage {
        id
        name
        isoCode
      }
    }
  }
  relations {
    languages {
      id
      name
    }
  }
}
    `;

/**
 * __useGetLanguagesForCreateBranchQuery__
 *
 * To run a query within a React component, call `useGetLanguagesForCreateBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesForCreateBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesForCreateBranchQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetLanguagesForCreateBranchQuery(baseOptions: Apollo.QueryHookOptions<GetLanguagesForCreateBranchQuery, GetLanguagesForCreateBranchQueryVariables> & ({ variables: GetLanguagesForCreateBranchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguagesForCreateBranchQuery, GetLanguagesForCreateBranchQueryVariables>(GetLanguagesForCreateBranchDocument, options);
      }
export function useGetLanguagesForCreateBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesForCreateBranchQuery, GetLanguagesForCreateBranchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguagesForCreateBranchQuery, GetLanguagesForCreateBranchQueryVariables>(GetLanguagesForCreateBranchDocument, options);
        }
export function useGetLanguagesForCreateBranchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLanguagesForCreateBranchQuery, GetLanguagesForCreateBranchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLanguagesForCreateBranchQuery, GetLanguagesForCreateBranchQueryVariables>(GetLanguagesForCreateBranchDocument, options);
        }
export type GetLanguagesForCreateBranchQueryHookResult = ReturnType<typeof useGetLanguagesForCreateBranchQuery>;
export type GetLanguagesForCreateBranchLazyQueryHookResult = ReturnType<typeof useGetLanguagesForCreateBranchLazyQuery>;
export type GetLanguagesForCreateBranchSuspenseQueryHookResult = ReturnType<typeof useGetLanguagesForCreateBranchSuspenseQuery>;
export type GetLanguagesForCreateBranchQueryResult = Apollo.QueryResult<GetLanguagesForCreateBranchQuery, GetLanguagesForCreateBranchQueryVariables>;
export type GetLanguagesForCreateBranchQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetLanguagesForCreateBranchQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string, isoCode: string }> | null, primaryLanguage?: { __typename?: 'LanguageProxy', id: number, name: string, isoCode: string } | null } | null } | null, relations: { __typename?: 'RelationProxy', languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string }> | null } };
